import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap'
import { TranslateModule } from '@ngx-translate/core'
import { AngularSvgIconModule } from 'angular-svg-icon'
import { ToastContainerComponent } from './toast-container.component'

@NgModule({
    declarations: [ToastContainerComponent],
    imports: [NgbToastModule, AngularSvgIconModule, TranslateModule, CommonModule],
    exports: [ToastContainerComponent]
})
export class ToastContainerModule {}
